import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import ScrollAnimation from '../components/ScrollAnimation';
import '../styles/NotFound.css';

const NotFound: React.FC = () => {
    const { t } = useTranslation();

    useEffect(() => {
        const previousTitle = document.title;
        document.title = '404 | Votera';

        const meta = document.createElement('meta');
        meta.name = 'robots';
        meta.content = 'noindex';
        document.head.appendChild(meta);

        return () => {
            document.title = previousTitle;
            meta.remove();
        };
    }, []);

    return (
        <div className='container'>
            <ScrollAnimation animation="fadeInUp" delay={0.1}>
                <section className='main-section not-found-section'>
                    <div className="not-found-content">
                        <div className="error-code">404</div>
                        <h1>{t('notFoundTitle')}</h1>
                        <h2>{t('notFoundSubtitle')}</h2>
                        <p>{t('notFoundDescription')}</p>
                        <div className="not-found-actions">
                            <Link to="/" className="home-button">
                                {t('notFoundGoHome')}
                            </Link>
                            <Link to="/kontakt" className="contact-button">
                                {t('notFoundContact')}
                            </Link>
                        </div>
                    </div>
                </section>
            </ScrollAnimation>
        </div>
    );
};

export default NotFound;
